const initialState = {
    identityServerUrl: undefined,
    apiServerUrl: undefined
};
const reducer = (state = initialState) => {
    return state;
};
export { reducer as SettingsReducer };
